import { addHours } from 'date-fns';

export const getCurrentDatePlus12Hours = (): Date => addHours(new Date(), 12);
